<template>
  <div style="height: 100%">
    <div class="hello jellomy">
      <el-container>
        <el-header style="height: auto">
          <Header></Header>
        </el-header>
      </el-container>
    </div>
  <keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
  </keep-alive>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
  <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Header from './Index/common/Header.vue'
import Api from "@/Serves/net-api.js";
import Http from "@/Serves/net-http.js";
import { mapActions } from "vuex"
export default {
  name: 'HoneIdex',
  components:{
    Header
  },
  beforeMount () {
    // if (window.location.hash !== '') {
    //   var url = decodeURIComponent(window.location.hash)
    //   var token = this.getCaption(url, "=")
    //   localStorage.setItem('token', token)
    // }
  },
  computed: {
  },
  created () {
    this.getAccountInfo()
  },
  mounted () {

  },
  methods: {
    ...mapActions(['getAccountInfo']),
    getCaption (url,parameter) {
      var index = url.lastIndexOf(parameter);
      url = url.substring(index + 1, url.length);
      return url;
    },
    addListener() {
      window.onmessage = function(e){//http://njjkht.dtwl360.com
        if (e.data.token !== undefined) {
          localStorage.setItem('userLevel', '1')
          localStorage.setItem( "token", e.data.token)
        }
      }
    }
  }
}
</script>
<style scoped>
  .el-header, .el-footer {
    color: #333;
    text-align: center;
    /* line-height: 60px; */
    background: #08172e!important;
    margin-bottom: 10px;
  }
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
  }
  .el-main {
    background-color: #08172e;
    color: #333;
    text-align: center;
  }
  body > .el-container {
    margin:0;
    padding: 0;
    /*margin-bottom: 40px;*/
  }
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  li.el-menu-item{
    padding: 0 77px;
  }
  .el-menu.el-menu--horizontal{
    border-bottom: none;
  }
  .el-header[data-v-8dc7cce2], .el-footer[data-v-8dc7cce2]{
    line-height: unset;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue